export var CommonStyle;
(function (CommonStyle) {
    CommonStyle.BTN_HEIGHT = 50;
})(CommonStyle || (CommonStyle = {}));
//# sourceMappingURL=CommonStyle.js.map